import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import axios from 'axios';

function Contact() {
  const [form, setForm] = useState({
    nom: '',
    email: '',
    telephone: '',
    sujet: '',
    message: '',
  });

  const [envoye, setEnvoye] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);

    try {
      await axios.post('https://efe-systems.com/api/contact', form);
      setEnvoye(true);
      setForm({
        nom: '',
        email: '',
        telephone: '',
        sujet: '',
        message: '',
      });
    } catch (error) {
      console.error('Erreur:', error);
      if (error.response && error.response.data) {
        setEnvoye(true);
      } else {
        alert("Une erreur est survenue. Veuillez réessayer.");
      }
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    background: '#f8f8f8',
    border: '1px solid rgba(0,0,0,0.1)',
    color: '#0F0F2D',
    borderRadius: '12px',
    padding: '12px 16px',
    width: '100%',
    outline: 'none',
    fontSize: '14px',
    boxSizing: 'border-box',
  };

  const infos = [
    {
      icone: '📍',
      titre: 'Adresse',
      valeur: '5, Rue Laferrière, Vivy Mitchel\nPétion-Ville, Haïti',
      couleur: '#1A1AE6',
    },
    {
      icone: '📱',
      titre: 'WhatsApp',
      valeur: '+509 3159-3212',
      lien: 'https://wa.me/50931593212',
      couleur: '#25D366',
    },
    {
      icone: '✉️',
      titre: 'Email',
      valeur: 'information@efe-systems.com',
      lien: 'mailto:information@efe-systems.com',
      couleur: '#EA4335',
    },
    {
      icone: '🕐',
      titre: "Heures d'ouverture",
      valeur: 'Lun – Ven : 8h00 – 17h00\nSam : 8h00 – 12h00',
      couleur: '#F5C500',
    },
  ];

  return (
    <div style={{ minHeight: '100vh', background: '#050510' }}>
      <Navbar />

      {/* HEADER */}
      <section
        className="w-full pt-32 pb-16 px-6 text-center"
        style={{
          background: '#050510',
          backgroundImage: `
            radial-gradient(ellipse 80% 50% at 20% 40%, rgba(26,26,230,0.12) 0%, transparent 60%),
            radial-gradient(ellipse 60% 40% at 80% 60%, rgba(107,33,232,0.10) 0%, transparent 60%),
            linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px)
          `,
          backgroundSize: 'auto, auto, 40px 40px, 40px 40px',
        }}
      >
        <div className="inline-flex items-center gap-2 px-4 py-1 rounded-full text-sm mb-4"
          style={{ background: 'rgba(26,26,230,0.1)', border: '1px solid rgba(26,26,230,0.3)', color: '#818CF8' }}>
          Contactez-nous
        </div>
        <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4">
          On est là pour{' '}
          <span style={{ color: '#F5C500' }}>vous aider</span>
        </h1>
        <p className="text-gray-400 text-lg max-w-xl mx-auto">
          Une question, un projet ou juste envie d'en savoir plus ? Écrivez-nous !
        </p>
      </section>

      {/* CONTENU PRINCIPAL */}
      <main className="max-w-6xl mx-auto px-6 pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">

          {/* FORMULAIRE */}
          <div className="rounded-3xl p-8"
            style={{ background: '#ffffff', border: '1px solid rgba(0,0,0,0.08)', boxShadow: '0 4px 30px rgba(0,0,0,0.1)' }}>

            {!envoye ? (
              <>
                <h2 className="text-2xl font-extrabold mb-2" style={{ color: '#0F0F2D' }}>
                  Envoyez-nous un message
                </h2>
                <p className="text-sm mb-6" style={{ color: '#6B7280' }}>
                  Remplissez le formulaire et notre équipe vous répondra dans les meilleurs délais.
                </p>

                <form onSubmit={handleSubmit} className="flex flex-col gap-4">

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="nom" className="text-gray-600 text-xs mb-1 block">Nom complet *</label>
                      <input id="nom" name="nom" type="text" value={form.nom} onChange={handleChange}
                        placeholder="Jean Pierre" required autoComplete="name" style={inputStyle} />
                    </div>
                    <div>
                      <label htmlFor="email" className="text-gray-600 text-xs mb-1 block">Email *</label>
                      <input id="email" name="email" type="email" value={form.email} onChange={handleChange}
                        placeholder="jean@exemple.com" required autoComplete="email" style={inputStyle} />
                    </div>
                  </div>

                  <div>
                    <label htmlFor="telephone" className="text-gray-600 text-xs mb-1 block">Téléphone</label>
                    <input id="telephone" name="telephone" type="tel" value={form.telephone} onChange={handleChange}
                      placeholder="+509 XXXX XXXX" autoComplete="tel" style={inputStyle} />
                  </div>

                  <div>
                    <label htmlFor="sujet" className="text-gray-600 text-xs mb-1 block">Sujet *</label>
                    <input id="sujet" name="sujet" type="text" value={form.sujet} onChange={handleChange}
                      placeholder="Comment pouvons-nous vous aider ?" required style={inputStyle} />
                  </div>

                  <div>
                    <label htmlFor="message" className="text-gray-600 text-xs mb-1 block">Message *</label>
                    <textarea id="message" name="message" value={form.message} onChange={handleChange}
                      rows={6} placeholder="Décrivez votre question ou besoin..." required
                      style={{ ...inputStyle, resize: 'vertical', minHeight: '140px' }} />
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full py-4 rounded-xl font-semibold text-lg transition hover:opacity-90 disabled:opacity-60"
                    style={{ background: '#1A1AE6', color: '#ffffff', cursor: loading ? 'not-allowed' : 'pointer', border: 'none' }}
                  >
                    {loading ? 'Envoi en cours...' : 'Envoyer le message →'}
                  </button>

                </form>
              </>
            ) : (
              <div className="text-center py-16">
                <div className="text-6xl mb-6">✅</div>
                <h2 className="text-2xl font-extrabold mb-3" style={{ color: '#0F0F2D' }}>
                  Message envoyé !
                </h2>
                <p className="mb-6" style={{ color: '#6B7280' }}>
                  Merci ! Nous vous répondrons dans les plus brefs délais.
                </p>
                <button
                  type="button"
                  onClick={() => setEnvoye(false)}
                  className="px-6 py-3 rounded-xl font-semibold transition hover:opacity-90"
                  style={{ background: '#1A1AE6', color: '#ffffff', border: 'none', cursor: 'pointer' }}
                >
                  Envoyer un autre message
                </button>
              </div>
            )}
          </div>

          {/* INFOS + MAP */}
          <div className="flex flex-col gap-6">

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {infos.map((info, index) => (
                <div key={index}
                  className="rounded-2xl p-5 transition hover:-translate-y-1 duration-300"
                  style={{ background: '#ffffff', border: '1px solid rgba(0,0,0,0.08)', boxShadow: '0 2px 15px rgba(0,0,0,0.05)' }}>
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center text-xl mb-3"
                    style={{ background: `${info.couleur}15`, border: `1px solid ${info.couleur}30` }}>
                    {info.icone}
                  </div>
                  <p className="text-gray-400 text-xs mb-1">{info.titre}</p>
                  {info.lien ? (
                    <a href={info.lien} target="_blank" rel="noopener noreferrer"
                      className="text-sm font-medium hover:opacity-80 transition"
                      style={{ textDecoration: 'none', whiteSpace: 'pre-line', color: '#0F0F2D' }}>
                      {info.valeur}
                    </a>
                  ) : (
                    <p className="text-sm font-medium" style={{ whiteSpace: 'pre-line', color: '#0F0F2D' }}>
                      {info.valeur}
                    </p>
                  )}
                </div>
              ))}
            </div>

            {/* GOOGLE MAPS */}
            <div className="rounded-3xl overflow-hidden"
              style={{ height: '320px', border: '1px solid rgba(0,0,0,0.08)', boxShadow: '0 2px 15px rgba(0,0,0,0.05)' }}>
              <iframe
                title="EFE Systems - Localisation"
                src="https://www.google.com/maps?q=5%20Rue%20Laferri%C3%A8re%2C%20Vivy%20Mitchel%2C%20P%C3%A9tion-Ville%2C%20Ha%C3%AFti&output=embed"
                width="100%" height="100%"
                style={{ border: 0, display: 'block' }}
                allowFullScreen loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>

            {/* WHATSAPP */}
            <a href="https://wa.me/50931593212" target="_blank" rel="noopener noreferrer"
              className="flex items-center justify-center gap-3 py-4 rounded-2xl font-semibold text-lg transition hover:opacity-90"
              style={{ background: '#25D366', color: '#ffffff', textDecoration: 'none' }}>
              <svg viewBox="0 0 24 24" className="w-6 h-6" fill="white">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.074-.57-.074-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              Nous contacter sur WhatsApp
            </a>

          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Contact;